module.exports = __webpack_public_path__ + "static/media/empty-state-wordpress-icon.30334d05.svg";